export function cleanCommaSplitStringList(list: string[]): string[] {
  const result: string[] = [];

  // Look through the list to identify if there is an open parenthesis without a closing parenthesis.
  // If there is, we need to find the closing parenthesis and merge the strings between the open and close parenthesis.
  // We also need to remove any empty strings from the list.

  let i = 0;
  while (i < list.length) {
    const item = list[i];

    if (item.includes("(") && !item.includes(")")) {
      let foundClosingParenthesis = false;
      let finalItem = item;
      // Look for the next item that has a closing parenthesis starting with the item after the current one:
      for (let j = i + 1; j < list.length; j++) {
        const nextItem = list[j];
        if (nextItem.includes(")")) {
          result.push(finalItem + ", " + nextItem);
          i = j + 1;
          foundClosingParenthesis = true;
          break;
        } else {
          finalItem += ", " + nextItem;
        }
      }
      if (!foundClosingParenthesis) {
        // If we didn't find a closing parenthesis, just give up.
        result.push(item);
        i++;
      }
    } else {
      result.push(item);
      i++;
    }
  }

  return result;
}
